<template>
  <div class="index_wrap">
    <div class="bg-left">
      <div class="logo">
        <img src="@/assets/images/logo-hdp.png" alt="logo" />
      </div>
      <div class="bg-text">
        <p>全球专线供应链服务平台</p>
      </div>
      <!-- <div class="bg-line"></div> -->
      <div class="bg-tips">货代版拼多多·让货代人都赚钱</div>
    </div>

    <div class="login_wrap">
      <!-- <div class="logoWrap">
        <div class="logo-3"></div>
      </div> -->
      <div class="wrap_count">
        <div class="login-page-title">货代拼供应商协作系统</div>
        <div class="tabsLIst">
          <div
            class="naverap"
            @click="handleClick(index)"
            :class="activeName == index ? 'active' : ''"
            v-for="(item, index) in navLIst"
            :key="index"
          >
            {{ item.name }}
            <span class="activeSapn" v-show="activeName == index"></span>
          </div>
        </div>
        <div class="count">
          <el-form
            style="width: 100%"
            :label-position="labelPosition"
            :model="formLabelAlign"
          >
            <el-form-item v-show="activeName == 0">
              <el-input
                class="login-input"
                clearable
                name="email"
                v-model="username"
                placeholder="请输入账号/邮箱"
              ></el-input>
            </el-form-item>
            <el-form-item v-show="activeName == 0">
              <el-input
                class="login-input"
                show-password
                name="password"
                type="password"
                v-model="password"
                placeholder="请输入密码"
                autocomplete="off"
                @keyup.enter.native="loginQd(activeName)"
              ></el-input>
            </el-form-item>
            <el-form-item v-show="activeName == 1">
              <el-input
                clearable
                class="login-input"
                name="phone"
                v-model="phone"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
            <el-form-item v-show="activeName == 1">
              <el-input
                class="login-input phone-code-input"
                @keyup.enter.native="loginQd(activeName)"
                clearable
                v-model="codenum"
                placeholder="请输入验证码"
                autocomplete="off"
                style="width: 317px;"
              ></el-input>
              <el-button @click="sendCode"
                         class="get-code"
                         :class="{ 'is-send-code': countDown > 0 }"
                         type="primary">{{
                          countDown <= 0 ? "获取验证码" : '重新获取(' + countDown + "S)"
                         }}
              </el-button>
            </el-form-item>
          </el-form>
          <el-button
            class="login-input login-submit-button"
            type="primary"
            @click="loginQd(activeName)"
          >登 录
          </el-button
          >
        </div>
        <div class="select-agreement">
          <el-checkbox class="login-checkbox"
                       v-model="value"
          >
            <p class="" style="color: #141414;font-size: 16px;">
              我已阅读并同意
              <span @click="registerPolicyDialog = true"
                    style="color: #FF4D01;font-size: 16px;">
                《货代拼用户服务条款》
              </span>
            </p>
          </el-checkbox>
        </div>
      </div>
    </div>

    <!-- 协议条款弹窗 -->
    <el-dialog
      title="服务条款"
      center
      :visible.sync="registerPolicyDialog"
      width="50%"
    >
      <!-- <div v-html="registerContext" style="text-align: center;"></div> -->
      <div style="">
        <p style="font-size: 26px">服务条款</p>
        <p>协议构成及须知</p>
        <p>
          1.
          本协议是货代拼网络平台注册用户（包括使用货代拼网络平台的个人和所代表的企业）与货代拼网络平台之间的法律契约，注册货代拼网络平台即代表接受本协议的约束，并自注册成功之时即成为本协议的一方（即货代拼用户）且自发出协议之时即受协议条款的约束。
        </p>
        <p>
          2.
          本协议受中华人民共和国法律管辖，签约地为深圳。下文中的货代拼是本协议的契约方之一。下文中的“用户”指货代拼网络平台注册用户，是本协议的契约方之另一方。
        </p>
        <p>
          3.
          用户欲访问和使用货代拼网络平台，必须事先认真阅读本协议中的各项条款，包括免除或者限制货代拼网络平台责任的免责条款及对用户的权利限制。请审阅并选择接受或不接受本协议。如不同意本协议条款或随时对其的修改，请不使用或主动取消货代拼网络平台提供的服务。对货代拼网络平台的使用行为将被视为对本协议条款的完全接受，包括接受货代拼网络平台对条款所做的任何修改。
        </p>
        <p style="font-size: 22px">用户使用规则</p>
        <p>
          1.
          货代拼网络平台服务仅限于为用户提供正常和合法业务工具，用户如果使用货代拼网络平台产品从事以下行为，即导致根本性违约，货代拼网络平台有权随时停止服务、解除本协议，并追讨因此带来的损失：
          1）有明确证据表明用户使用货代拼网络平台用于违反法律的业务。用户发送了任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、淫秽等内容的信息。
          2）对货代拼网络平台产品进行了任何形式的对其他第三方的再授权使用，销售或转让。
          3）提供的公司信息或个人资料不真实，或有可能对货代拼网络平台其他用户构成误导甚至欺诈。
          4）滥用货代拼网络平台产品的通信功能发送垃圾邮件和短信。
          5）对货代拼网络平台的连续服务和商誉构成损害的其他行为，包括对货代拼网络平台服务器的攻击。
          6）其他货代拼网络平台认为是不符合整体服务需求的特殊情形。
        </p>
        <p>
          2.
          货代拼网络平台使用用户所拥有的互联网域名所对应的电子邮件地址作为用户权证的唯一识别信息。当用户不再拥有在货代拼网络平台所登记的域名时，货代拼网络平台有权随时删除该用户的所有数据。
        </p>
        <p>
          3.
          用户必须自行配备上网和使用电信增值业务所需的设备，自行负担上网或第三方（包括但不限于电信或移动通信提供商）收取的通讯费、信息费等有关费用。如涉及电信增值服务的，请与您的电信增值服务提供商确认相关的费用问题。
        </p>
        <p style="font-size: 22px">知识产权</p>
        <p>
          1.
          用户完全拥有在使用货代拼网络平台时创建的数据和资料（包括但不限于：货物资料、价格数据、客户资料、联系人等信息）的所有权，并有权进行任何形式的处置，包括从货代拼网络平台中复制、导出和删除。
        </p>
        <p>
          2.
          航迅（深圳）网络科技有限公司完全拥有货代拼网络平台的全部知识产权，用户签署本协议后并未拥有货代拼网络平台的所有权。航迅（深圳）网络科技有限公司的公司名称、标志、LOGO、产品名字，以及货代拼网络平台的应用程序、源代码、界面设计、应用程序编程接口（API）等所关联的知识产权都归属航迅（深圳）网络科技有限公司，未经授权不能使用。
        </p>
        <p>
          3.
          用户不得将涉及货代拼网络平台拥有知识产权的相关内容用于本协议范围以外的任何商业目的或泄露给第三方。用户不得出售、转售或复制货代拼网络平台产品，亦不可基于商业目的模仿货代拼网络平台的产品和服务。用户不可复制和模仿货代拼网络平台的设计理念、界面、功能和文字及图形说明。未经航迅（深圳）网络科技有限公司许可，用户不得基于此协议所约定的服务对货代拼网络平台进行修改或制造、衍生其它产品。
        </p>

        <p style="font-size: 22px">数据安全及保密</p>

        <p>
          1.
          货代拼网络平台每天都对用户储存在货代拼服务器上的数据信息进行异地备份，做好冗灾预防机制，以确保在系统发生问题后，可以快速恢复系统正常运行。
        </p>
        <p>
          2.
          用户有义务维护自己在货代拼网络平台中的账户信息的完整性、密码的保密性。因用户维护或保密不善致使相关信息泄露，或由于第三方盗用用户帐号和密码进行各种操作而造成的损失，由用户自行负责。用户不得向他人提供货代拼网络平台的全部或部分服务，也不得容许他人通过自己的账户使用货代拼网络平台。
        </p>
        <p>
          3.
          货代拼的客服人员不接受用户的口头请求对其密码进行重置。对所有用户输入的信息和上传的文件，
          货代拼员工不能对其进行其他任何侵犯隐私的操作。
        </p>
        <p>
          4.
          用户对其输入数据的准确性、可靠性、合法性、适用性等自行负责。用户不可破坏货代拼网络平台的安全或授权措施，不可翻阅或存取非自己所有的数据。
        </p>
        <p>
          5.
          除应政府或司法机关调查或法律要求外，航迅（深圳）网络科技有限公司直接口头或书面向第三方提供涉及用户在使用货代拼网络平台过程中保存在货代拼服务器上的数据的行为属于泄密行为，所造成对用户的直接损失，并经证实，用户有权通过法律途径要求货代拼按协议相应条款赔偿。
        </p>
        <p>
          6.
          本条款中的保密义务、权利和责任不适用于如下信息：(1)非由于货代拼不正当的原因已经为公众所知的；(2)由货代拼以外其他渠道被他人获知的信息，这些渠道并不受保密义务的限制；(3)经用户授权发布的信息;
          (4)由于法律、法院或其他国家有权机关的要求而披露的信息。
        </p>
        <p>
          7.
          货代拼保留使用汇总统计信息的权利，但这些信息是匿名，且不针对特定用户的。
        </p>
        <p>
          8.
          航迅（深圳）网络科技有限公司保留面向基础版用户刊载广告的权利，这些广告刊载过程中将可能使用必要的定向技术来提高广告相关度，但货代拼不会将用户的个人信息透露给广告商，而只会在匿名的基础上通过自动化匹配技术实现广告优化刊载。
        </p>
        <p style="font-size: 22px">不可抗力及免责条款</p>
        <p>
          1.
          因一切不由货代拼可控因素引起的服务中断和长时间终止不属于货代拼违约，不承担赔偿责任。不可控因素包括但不限于：
          1）用户方客户终端硬件及网络，互联网络，机房供电系统故障；
          2）不可抗力： 地震、台风、洪水等自然灾害；
          战争、罢工、停电、政府行为等； 政府电力部门或电信部门的行为；
          电信线路被人为破坏或骨干网线路、设备因调试、扩容所引起的中断；
          INTERNET公网阻塞或其他通路（如访问目的地的服务器响应速度）问题；
          外部人为破坏因素引起的，超过安全设备的承载能力。
          3）其它不可预见、不可避免、不可克服和不可控制的不可抗力。
        </p>
        <p>
          遭受不可抗力的一方应采取一切必要措施减少损失，并在事件消除后协商恢复本合同的履行。
        </p>

        <p>
          2.
          货代拼不保证网址所载公开信息、软件演示和免费软件服务内容的准确性、可靠性或完整性，并明确地否认就该等信息和软件功能的错误或遗漏承担责任；并不对信息和免费软件做出任何种类的保证，包括（但不限于）有关没有侵犯第三方权利、所有权、适销性、质量令人满意、适合特定的用途和没有计算机病毒的保证。
        </p>
        <p>
          3.
          货代拼对任何损害概不负责，无论这些损害是否由于使用、不能使用本平台的结果或由连到本平台的任何Web网站或者任何这类网站中包含的信息所引起（包括但不限于由损失的利润、损失的数据或业务中断而造成的损害），也不管它们是否有保证、合同、侵权行为或任何其它法律根据以及事前已得到这类损害可能发生的消息。如果用户由于使用本站的免费信息和免费软件版本导致需要对设备或数据进行维护、修理或纠正，用户须承担由此而造成的所有费用。
        </p>
        <p>
          4.
          在任何情况下，货代拼对于与使用或未能使用本平台或任何链接的网站免费的内容、资料、软件功能有关任何直接的、间接的、特殊的、连带的或其它损失（包括但不限于任何利润损失、业务中断以及您的信息处理系统中的信息或程序或其它数据的丢失）不向任何机构承担责任。
        </p>
        <p>
          5.
          货代拼网络平台、论坛、博客中的所有言论并不代表货代拼的观点。这里所指的言论包括新闻及动态但不仅限于此。如果上面的言论对用户造成伤害，货代拼将协助您及有关部门依据相关法律法规清除相关内容并查找IP记录，但货代拼不承担任何责任。
        </p>
        <p style="font-size: 22px">条款修订</p>
        <p>
          1.
          货代拼有权随时对本协议的条款进行修订，并在修订生效日前三个工作日更新在货代拼网站。
        </p>
        <p>2. 修订的条款始终公开在货代拼网络平台条款页面</p>
        <p style="font-size: 22px">争议解决</p>
        <p>
          如果就本协议的解释或执行发生争议，双方应首先力争通过友好协商解决该争议。本协议在执行过程中发生争议时，双方可协商解决；不能协商解决的，可向乙方所在地人民法院提起诉讼。在上述磋商或诉讼期间，双方应继续履行争议部分之外的本合同项下各自义务。
        </p>
      </div>
    </el-dialog>
    <!-- 协议条款弹窗 end -->
  </div>
</template>

<script>
  import qs from "qs";
  import Utils from "../../../common/util.js";
  import loginType from "../../../common/loginType";
  import {sendCustomerOperationRecord} from "../../assets/js/baseDataRuquest";

  export default {
    components: {
      loginType,
    },
    data() {
      return {
        registerPolicyDialog: false,
        logintType: null,
        value: true,
        countDown: 0,
        navLIst: [{name: "账号登录"}, {name: "手机登录"}],
        width: "380px",
        dialogTableVisible: false,
        activeName: 0,
        labelPosition: "right",
        formLabelAlign: {
          name: "",
          region: "",
          type: "",
        },
        username: "",
        password: "",
        phone: "",
        codenum: "",
      };
    },
    watch: {
      countDown(val) {
        if (val <= 0) {
          clearInterval(this.timer);
        }
      },
    },
    computed: {},
    methods: {
      // 显示注册弹窗
      goRegister() {
        // console.log('123')
        this.$emit('openRegister')
        this.$parent.$parent.openRegister()
      },
      loginQd(activeName) {
        if (this.activeName == 1) {
          if (!this.isPhone()) {
            this.$message({message: "请输入正确的手机号码"});
            return;
          }
        }
        let that = this;
        if (!this.value) {
          return this.$message({message: "请您先同意服务协议！"});
        }
        if (this.activeName == 1) {
          if (this.phone && this.codenum) {
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            let params = {};
            params = {
              phoneNo: this.phone,
              smsCode: this.codenum,
            };
            this.axios
              .post("/carrier/auth/loginBySmsCode", qs.stringify(params))
              .then((res) => {
                console.log(res);
                if (res.data.code == "200") {
                  let Authorization = res.data.data;
                  localStorage.setItem('before_phone', params.phoneNo)
                  localStorage.setItem(
                    "Authorization_lineSupplier",
                    JSON.stringify(Authorization)
                  );
                  sessionStorage.setItem(
                    "Authorization_lineSupplier",
                    JSON.stringify(Authorization)
                  );
                  sendCustomerOperationRecord('登录', '登录')
                  that.$message({message: "登录成功", type: "success"});
                  loading.close();
                  this.$router.push({
                    name: "platformSharedWarehouse",
                  });
                  if (this.logintType == 2) {
                    that.$parent.getFiledata("login");
                  }
                  that.$store.commit("addUserdata", res.data.data);
                } else {
                  that.$message.info(res.data.message);
                  loading.close();
                }
              })
              .catch((res) => {
                console.log(res);
              });
          } else {
            this.$message.info("请输入手机号或验证码");
          }
        } else {
          if (this.username && this.password) {
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            let params = {};
            params = {
              password: this.password,
              username: this.username,
            };
            this.axios
              .post("/carrier/auth/login", qs.stringify(params))
              .then((res) => {
                if (res.data.code == "200") {
                  let Authorization = res.data.data;
                  localStorage.setItem('before_email',this.username);
                  localStorage.setItem("Authorization_lineSupplier", JSON.stringify(Authorization));
                  sendCustomerOperationRecord('登录', '登录')
                  that.dialogTableVisible = false;
                  loading.close();
                  if (this.logintType == 2) {
                    that.$parent.getFiledata("login");
                  }
                  that.$message({message: "登录成功", type: "success"});
                  that.$store.commit("addUserdata", res.data.data);
                  this.$router.push({
                    name: "platformSharedWarehouse",
                  });
                } else {
                  that.$message.info(res.data.message);
                  loading.close();
                }
              })
              .catch((res) => {
                console.log(res);
              });
          } else {
            this.$message.info("请输邮箱或密码");
          }
        }
      },
      sendCode() {
        if (!this.isPhone()) {
          this.$message({message: "请输入正确的手机号码"});
          return;
        }
        if (this.countDown != 0) {
          this.$message({message: "请" + this.countDown + "秒后再发送"});
          return;
        }
        this.axios
          .get(`/api/carrier/auth/requestCarrierLoginSmsCode/${this.phone}`)
          .then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.$message({message: res.data.message});
              clearInterval(this.timer);
              this.countDown = 30;
              this.timer = setInterval(() => {
                this.countDown--;
              }, 1000);
            } else {
              this.$message({message: res.data.message});
            }
          });
      },
      isPhone() {
        let mPattern = /^1[34578]\d{9}$/;
        return mPattern.test(this.phone);
      },
      handleClick(index) {
        this.activeName = index;
      },
      showDialog(num) {
        this.logintType = num;
        console.log(num);
        this.dialogTableVisible = true;
      },
      handleScroll() {
        let scrolltop =
          document.documentElement.scrollTop || document.body.scrollTop;
        scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
      },
      very() {
        if (!this.submitForm.name) {
          this.$message.info("联系人不能为空！");
          return false;
        }
        // 派送不校验
        if (this.getLIstType != "PS") {
          if (!/^1[3456789]\d{9}$/.test(this.submitForm.tel)) {
            this.$message.info("手机号码有误，请重填");
            return false;
          }
        }

        // 城市
        if (!this.submitForm.city) {
          this.$message.info("联系地址不能为空！");
          return false;
        }
        // 区
        if (!this.submitForm.area) {
          this.$message.info("联系地址不能为空！");
          return false;
        }
        if (!this.submitForm.address) {
          this.$message.info("详细地址不能为空！");
          return false;
        }
        if (this.submitForm.tag) {
          if (this.submitForm.tag.length > 5) {
            this.$message.info("标签长度不能超过五个字符");
            return false;
          }
        }

        return true;
      },
    },

    created() {
      if (this.$store.state.Authorization) {
        this.$router.replace('/index/PersonalCenter/Personalindex/PersonalCenter/platformSharedWarehouse')
      }
    },
    mounted() {
      var that = this;
      Utils.$on("demo", function (num) {
        that.showType(num);
      });
      window.addEventListener("scroll", this.handleScroll, true);
      this.$nextTick(()=>{
        let beforeEmail = localStorage.getItem('before_email');
        if(beforeEmail){
          this.username = beforeEmail;
        }
        let before_phone = localStorage.getItem('before_phone');
        if (before_phone){
          this.phone = before_phone;
        }
      });

    },
  };
</script>
<style lang="scss" scoped>
input:-webkit-autofill {
  box-shadow: 0 0 0 1000px #ffffff inset !important;
}
.el-form-item{
  margin-bottom: 30px;
}
.el-input /deep/.el-input__inner{
  height: 55px;
  border-radius: 4px;
  border-color: #EEE;
  color: #141414;
  &::placeholder {
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
  }
}
.login-input{
  font-size: 16px;
  .el-input__suffix-inner .el-input__icon{
    font-size: inherit;
  }
  input{
    font: inherit;
  }
  &.login-submit-button{
    width: 100%;
    height: 54px;
    border-radius: 4px;
    /*color: #fff;*/
    /*background-color: #FF4D01;*/
    /*border-color: #FF4D01;*/
    /*&:hover {*/
    /*background: #c7616c;*/
    /*border-color: #c7616c;*/
    /*color: #fff;*/
    /*}*/
  }
}
.get-code{
  width: 122px;
  height: 55px;
  margin-left: 17px;
  font-size: 16px;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
}
.is-send-code {
  background: #DDDDDD;
  border-color: #DDDDDD;
  cursor: not-allowed;
  &:hover {
    border-color: #DDDDDD;
    background: #DDDDDD;
  }
}
/*短信验证码*/
.phone-code-input{
  .el-input__inner{
    height: 55px;
    border-radius: 4px;
    border-color: #EEE;
    color: #141414;
    &::placeholder {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 22px;
    }
  }
  .el-input-group__append {
    background-color: transparent;
    /*border-color: transparent;*/
    border-radius: 0 7px 7px 0;
    border: none;
    .get-code.el-button {
      color: #FF4D01;
      background-color: #FFE3E6;
      /*border-color: #FFCBD1;*/
      border: none;
      border-radius: 0 7px 7px 0;
      &:hover {
        color: #c7616c;
        background-color: rgba(255, 203, 209, 0.8);
        border-color: rgba(255, 203, 209, 0.8);
      }
    }
  }
}
  $text-color: #141414;
  .index_wrap,
  .login_wrap{
    box-sizing: border-box;
  }
  .index_wrap {
    overflow: hidden;
    width: 100%;
    height: 100%;
    background-image: url("https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0/pages/supplierSystem/login_bg.png");
    /*background-image: url("../../assets/images/logon_bg.png");*/
    background-repeat: no-repeat;
    background-size: cover;
  }
  .login_wrap{
    margin: 0 auto;
    width: 100%;
    max-width: 1366px;
    height: 100%;
    background-repeat: no-repeat;
    background-position: left 55px;
    background-size: 843px auto;
    position: relative;
  }
  .logoWrap {
    margin-top: 55px;
    margin-left: 74px;
    height: 42px;
    .logo-3 {
      /*position: absolute;*/
      /*top: 39px;*/
      /*left: 5%;*/
      display: block;
      border: none;
      width: 166px;
      height: 63px;
      background-image: url("../../assets/images/logo-hdp.png");
      background-size: 166px auto;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .botText {
    width: 100%;
    text-align: right;
    margin-top: 28px;
  }
  .wrap_count {
    // float: right;
    // margin-top: 44px;
    // /*margin-right: 176px;*/
    // margin-right: 9%;
    // width: 26%;
    // max-width: 400px;
    // min-width: 400px;
    // display: flex;
    // display: -webkit-flex;
    // align-items: center;
    // justify-content: center;
    // flex-direction: column;
    width: 560px;
    height: 528px;
    box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.2);
    border-radius: 12px;
    background-color: #fff;
    position: absolute;
    right: -122px;
    box-sizing: border-box;
    padding: 32px 50px;
    top: 40px;
    transform: translateY(-50%);
    top: 50%;

    .login-page-title {
      width: 100%;
      font-size: 30px;
      font-weight: 600;
      color: $text-color;
      line-height: 42px;
      margin-bottom: 50px;
      font-family: PingFangSC, PingFang SC, Source Han Sans CN;
    }
    .tabsLIst {
      width: 100%;
      margin-bottom: 42px;
      .naverap {
        display: inline-block;
        position: relative;
        font-size: 22px;
        font-weight: 600;
        font-family: PingFangSC, PingFang SC;
        color: $text-color;
        line-height: 30px;
        padding-bottom: 6px;
        cursor: pointer;
        &:first-child {
          margin-right: 86px;
        }
        &.active {
          color: #FF4D01;
          border-bottom: 2px solid #FF4D01;
        }
      }
      .activeSapn {
        width: 41px;
        height: 2px;
        /*background: #5f4aff;*/
        position: absolute;
        bottom: -4px;
        left: 6px;
      }
    }
    .count {
      width: 100%;
    }
    .select-agreement {
      width: 100%;
      margin-top: 30px;
    }
  }

  .bg-left {
    width: 900px;
    height: 670px;
    // background-color: #fff;
    position: absolute;
    top: 196px;
    left: 219px;
    // border: 1px solid white;
  }
  .bg-text {
    margin-top: 22px;
    padding-left: 25px;
    font-size: 60px;
    font-family: PingFangSC, PingFang SC, Source Han Sans CN;
    font-weight: 600;
    color: $text-color;
    line-height: 78px;
    letter-spacing: 12px;
  }
  .bg-line{
    width: 500px;
    background: $text-color;
    height: 3px;
    margin: 30px 0;
  }

  .bg-tips {
    margin-top: 10px;
    padding-left: 25px;
    font-size: 42px;
    font-family: PingFangSC, PingFang SC, Source Han Sans CN;
    font-weight: 400;
    line-height: 59px;
    letter-spacing: 10px;
    color: $text-color;
  }



</style>



// WEBPACK FOOTER //
// src/components/placeOrder/placeIndex.vue